<template>
  <el-form @submit.native.prevent="$emit('save')" >
    <h3>Filtres</h3>
    <multiple-cascader
       ref="filterCascader"
       v-model="myFilters"
       :min="0"
       add-text="Ajouter un filtre"
       :props="dimensionProps"
       :load-children="dimensionLoad"
       :title="i => 'Filtre ' + i"
       :options="dimensions"
       :createNew="createNewFilter"
       :value-options="filterOptions" >
      <template slot="more" slot-scope="{data, internal, i}" >
        <el-form-item class="default-filter" >
          <component
             v-if="data.options.type && data.value"
             :is="data.options.type + '-filter'"
             :class="data.options.type + '-filter'"
             :data="data"
             placeholder="valeur par défaut"
             @change="val => setDefaultFilter(data, i, val)" />
        </el-form-item>
        <el-form-item>
          <el-radio-group
             v-model="internal.state"
             @change="val => setState(internal, i, val)" >
            <el-radio label="editable" >Public</el-radio>
            <el-radio label="private" >Privé</el-radio>
            <el-radio label="hidden" >Caché</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Clef" >
          <el-input v-model="internal.key" @change="val => setKey(internal, i, val)" />
        </el-form-item>
      </template>  
    </multiple-cascader>
    <div style="text-align: right;">
      <el-button
         plain
         native-type="submit">
        Sauvegarder
      </el-button>
    </div>
  </el-form>
</template>

<script>
import {api} from 'macarons'
import MultipleCascader from './MultipleCascader.vue'
import * as filters from './filter'
import customGraphApiAware from './mixins/customGraphApiAware'
import customGraphApi from './api'

export default {
  props: {
    filters: {
      type: Array
    }
  },
  mixins: [
    customGraphApiAware
  ],
  data () {
    return {
      dimensionProps: {
        label: customGraphApi.dimension.props.name,
        value: customGraphApi.dimension.props.uniqueName,
        children: 'children',
        disabled: 'disabled'
      },
      filterOptions: [
        {
          key: 'type',
          options: [
            {key: 'single-select', label: 'Liste de sélection'},
            {key: 'select', label: 'Liste de sélection multiple'},
            {key: 'range', label: 'Plage de donnée'},
            {key: 'hierarchy', label: 'Hiérarchie'}
          ]
        }
      ],
      myFilters: this.filters
    }
  },
  computed: {
    dimensions () {
      return this.$store.getters['customGraph/dimensions']
    }
  },
  methods: {
    dimensionLoad (dimension) {
      this.$store.dispatch('customGraph/loadDimension', this.api.dimension.uniqueName(dimension))
    },
    setState (data, i, val) {
      this.myFilters[i].state = val
      this.$emit('update:filter', this.myFilters)
    },
    setKey (data, i, val) {
      this.myFilters[i].key = val
      this.$emit('update:filter', this.myFilters)
    },
    createNewFilter () {
      return {
        defaultValues: [],
        state: 'editable',
        key: null
      }
    },
    setDefaultFilter (data, i, val) {
      data.defaultValues.splice(0, data.defaultValues.length, ...val.values)
      this.$emit('update:filter', this.myFilters)
    }
  },
  components: {
    MultipleCascader,
    ...filters
  },
  watch: {
    myFilters () {
      this.$emit('update:filters', this.myFilters)
    }
  }
}
</script>

<style scoped>
.filters {
    display: flex;
    flex-basis: 150px;
    flex-wrap: wrap;
}
.filters .el-form-item, .filters .merged-graph-filter {
    padding: 0 5px;
    margin-left: 0.4em;
    margin-right: 0.2em;
    margin-bottom: 0.4em;
}
</style>
<style>
.filters .el-slider__runway {
  margin: 8px 0;
}
.filters .el-select__tags-text {
  max-width: 170px;
  overflow: hidden;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/GlobalFiltersWidgetEdit.vue